import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { H3, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import { useFormSlotWithoutRedux } from '../../../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../../../slots/summaries/summary-context.js';
import '../../../../slots/summaries/types.js';
import { seedFieldState } from '../../../../StepShipping/mappers/seed-shipping-form.js';
import { formStatesToValues } from '../../../utils/form-state-to-values.js';
import { isFormDataValid } from '../../../utils/validate-form-data.js';

const CompanySummary = ({ companyDetails , onSubmit , isOrderDetailsValid  })=>{
    const { getLabel  } = useIntl();
    const { formFieldsMap  } = useCheckoutSettings();
    const filledFormData = companyDetails && Object.entries(companyDetails).reduce((item, [key, value])=>swcHelpers.objectSpread({}, item, {
            [key]: seedFieldState(key, value)
        })
    , {});
    const [companyDetailsState, setCompanyDetailsState] = React.useState();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const handleSubmit = React.useCallback((companyFormState)=>{
        const updatedCompanyDetails = companyDetailsState && formStatesToValues(companyFormState.formState);
        updatedCompanyDetails && (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
            company: updatedCompanyDetails
        }));
        setIsModalOpen(false);
    }, [
        companyDetailsState,
        onSubmit
    ]);
    const { company: companyForm  } = useFormSlotWithoutRedux({
        formInitialData: filledFormData ? {
            company: filledFormData
        } : {},
        onChange: setCompanyDetailsState,
        onSubmit: handleSubmit,
        onCancel: ()=>setIsModalOpen(false)
        ,
        className: 'login-express-checkout__form-modal__form login-express-checkout__form-modal__form--with-custom-height'
    });
    const isCompanyDetailsFormComplete = React.useMemo(()=>{
        var ref;
        return (formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.company) ? (ref = isFormDataValid(formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.company, companyDetails)) !== null && ref !== void 0 ? ref : false : false;
    }, [
        companyDetails,
        formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.company
    ]);
    const labels = {
        title: getLabel('checkout.customerType.company'),
        save: getLabel('common.actions.save')
    };
    const { Slots  } = useBaseSummarySlot();
    if (!Slots.company) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        className: "login-express-checkout__form-modal",
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true
    }, /*#__PURE__*/ React.createElement(H3, {
        variant: "body-head"
    }, labels.title), /*#__PURE__*/ React.createElement(React.Fragment, null, companyForm)), /*#__PURE__*/ React.createElement(Slots.company, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: companyDetails,
        errorNotification: !isCompanyDetailsFormComplete ? /*#__PURE__*/ React.createElement(Alert, {
            role: isOrderDetailsValid ? 'status' : 'alert',
            className: "alert-m-default ",
            variant: isOrderDetailsValid ? 'info' : 'error',
            title: getLabel('checkout.company.incomplete.title')
        }, getLabel('checkout.information.incomplete.message')) : null
    }));
};

export { CompanySummary };
//# sourceMappingURL=CompanySummary.js.map
